import { atom } from "jotai"


export const selectedType = atom<{ value: string; label: string }>({ value: "jugadores", label: "jugadores" })

export const showImageModal = atom(false)

export const languageCode = atom ({itemID: ''})

export const teamID = atom ('')